import './App.css';
import AppRouter from './Configuration/router';
function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
